export default (initialState = {}) => {
  return () => {
    return {
      agent: {
        _id: null,
        name: "",
        commission_percent: 0,
        commission_rate: 0,
        commission_type: "percent",
      },

      buyer: null,

      deal_lead: "",

      delay_attribution: "",
      delay_interest_percent: null,

      grace_period: 0,

      is_gst_amount_hold: true,

      is_prorata_enabled: true,

      net_sales_margin_percent: null,
      margin_money_provider: "",

      payment_distribution: {
        grn: 0,
        gst_hold: 5,
        margin_money: 0,
        quality_check: 0,
        payment_received: 0,
      },
      grn_payment_delay_days: 0,

      virtual_credit_cycle: null,
      virtual_credit_start_date: null,

      seller: null,
      is_active: true,
      roce_percentage: 2,
      approvers: [],
      files: [],
      ...initialState,
    };
  };
};
